import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { GetDetailsAPIResponse, OrganizationDetails } from './settingstypes';

type TenantDetailsResponse = GetDetailsAPIResponse | OrganizationDetails | null;

interface TenantState {
  tenantDetailsResponse: TenantDetailsResponse;
}

interface TenantMetadataPayload {
  meta_data: Record<string, unknown>;
  default_timezone?: string;
}

const initialState: TenantState = {
  tenantDetailsResponse: null,
};

const tenantSlice = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    setTenantDetailsResponse: (state, action: PayloadAction<TenantDetailsResponse>) => {
      state.tenantDetailsResponse = action.payload;
    },
    setTenantMetadata: (state, action: PayloadAction<TenantMetadataPayload>) => {
      if (!state.tenantDetailsResponse) {
        state.tenantDetailsResponse = {
          org_name: '',
          meta_data: { ...(action.payload.meta_data ?? {}) },
          ...(typeof action.payload.default_timezone === 'string'
            ? { default_timezone: action.payload.default_timezone }
            : {}),
        };
        return;
      }

      const target = ((state.tenantDetailsResponse as any)?.data ?? state.tenantDetailsResponse) as Record<string, any>;
      target.meta_data = {
        ...(target.meta_data ?? {}),
        ...(action.payload.meta_data ?? {}),
      };
      if (typeof action.payload.default_timezone === 'string') {
        target.default_timezone = action.payload.default_timezone;
      }
    },
    clearTenantDetailsResponse: (state) => {
      state.tenantDetailsResponse = null;
    },
  },
});

export const { setTenantDetailsResponse, setTenantMetadata, clearTenantDetailsResponse } = tenantSlice.actions;
export default tenantSlice.reducer;
